import { scrollToId } from "./scroll";

const KEY = "edl-promo-offer";
export const PROMO_EVENT = "edl-promo-applied";

/** Banderole / encart : mémorise l'offre, notifie le formulaire, amène au contact. */
export const applyPromoOffer = () => {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch (e) {}
  window.dispatchEvent(new Event(PROMO_EVENT));
  scrollToId("contact");
};

export const hasPromoOffer = () => {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const clearPromoOffer = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {}
};
